export interface TransferPurchaseInfo {
  id?: number
  basisId: number
  amortStartDate?: string
  amortStartPrice?: number
  derivedAmortStartCost?: number
  derivedAmortStartPrice?: number
  derivedFactor?: number
  amortStartYield: number
  amortOverride?: string
  origTradeDate: string
  origSettleDate: string
  origPrice?: number
  origYield: number
  valuationDate: string
  commission: number
  factor: number
  origAccruedInt?: number
  amortStartCost?: number
  fxOrigCost?: number
  fxBookValueAtLoad?: number
  localAccruedAtLoad?: number
  fxAccruedAtLoad?: number
  accruedMarketDiscount?: number
  fxAccruedMarketDiscount?: number
  accumulatedOtti?: number
  fxAccumulatedOtti?: number
  washSaleDeferredLoss?: number
  fxWashSaleDeferredLoss?: number
  taxDaysHeld?: number
  daysImpaired?: number
  origCost?: number
  fxRateAtOrigEntry?: number
  originalOriginationFee?: number
  exitFee?: number
  exitFeeReceivable?: number
  drawFee?: number
  prepaymentPenaltyFee?: number
  prepaidInterest?: number
  interestDue?: number
  interestBearingInterestReserve?: number
  interestBearingPrincipalReserve?: number
  nonInterestBearingInterestReserve?: number
  nonInterestBearingPrincipalReserve?: number
  straddleDeferredLoss?: number
  fxStraddleDeferredLoss?: number
  section1256DeferredLoss?: number
  fxSection1256DeferredLoss?: number
  lpCumulativeEarnings?: number
  lpCumulativeDistributions?: number
  returnOfInvestment?: number
  returnOnInvestment?: number
}

export const TpiPropertiesNumeric = [
  'id',
  'basisId',
  'amortStartPrice',
  'derivedAmortStartPrice',
  'amortStartYield',
  'origPrice',
  'origYield',
  'valuationDate',
  'commission',
  'factor',
  'derivedFactor',
  'origAccruedInt',
  'amortStartCost',
  'derivedAmortStartCost',
  'fxOrigCost',
  'fxBookValueAtLoad',
  'localAccruedAtLoad',
  'fxAccruedAtLoad',
  'accruedMarketDiscount',
  'fxAccruedMarketDiscount',
  'accumulatedOtti',
  'fxAccumulatedOtti',
  'washSaleDeferredLoss',
  'fxWashSaleDeferredLoss',
  'taxDaysHeld',
  'daysImpaired',
  'origCost',
  'fxRateAtOrigEntry',
  'originalOriginationFee',
  'exitFee',
  'exitFeeReceivable',
  'drawFee',
  'prepaymentPenaltyFee',
  'prepaidInterest',
  'interestDue',
  'interestBearingInterestReserve',
  'interestBearingPrincipalReserve',
  'nonInterestBearingInterestReserve',
  'nonInterestBearingPrincipalReserve',
  'straddleDeferredLoss',
  'fxStraddleDeferredLoss',
  'section1256DeferredLoss',
  'fxSection1256DeferredLoss',
  'lpCumulativeEarnings',
  'lpCumulativeDistributions',
  'returnOfInvestment',
  'returnOnInvestment',
]

export const TpiPropertiesString = [
  'amortStartDate',
  'amortOverride',
  'origTradeDate',
  'origSettleDate',
  'valuationDate',
]
